import React, { useState, useEffect } from "react";
import { Tabs, Descriptions } from "antd";
import { Container, Col, Row } from "react-bootstrap";
import Common from "./includes/Common";
import NewPrescription from "./forms/NewPrescription";
import { EyeFill, SlashSquareFill, Tools, BandaidFill, Eyeglasses } from "react-bootstrap-icons";
import NewPharmacyPrescription from "./forms/NewPharmacyPrescription";
import NewGlassPrescription from "./forms/NewGlassPrescription";
import NewChirurgyPrescription from "./forms/NewChirurgyPrescription";
import NewLaserPrescription from "./forms/NewLaserPrescription";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Prescriptions = function Prescriptions(_ref) {
  var _ref$patient = _ref.patient,
      patient = _ref$patient === void 0 ? null : _ref$patient,
      _ref$check = _ref.check,
      check = _ref$check === void 0 ? null : _ref$check,
      handler = _ref.handler;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius",
            style: {
              background: '#FCD013'
            },
            children: /*#__PURE__*/_jsxs(Descriptions, {
              title: /*#__PURE__*/_jsx("b", {
                children: "CONSULTATION"
              }),
              column: 1,
              children: [/*#__PURE__*/_jsx(Descriptions.Items, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Nom"
                }),
                children: patient.lastname
              }), /*#__PURE__*/_jsx(Descriptions.Items, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Pr\xE9nom"
                }),
                children: patient.firstname
              }), /*#__PURE__*/_jsxs(Descriptions.Items, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Motif"
                }),
                children: [check.reason.substring(0, 96), " ..."]
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 9,
          children: /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(EyeFill, {
                  size: 30
                }), "EXPLORATION"]
              }),
              children: /*#__PURE__*/_jsx(NewPrescription, {
                patient: patient,
                check: check,
                handler: handler
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(BandaidFill, {
                  size: 30
                }), "PHARMACIE"]
              }),
              children: /*#__PURE__*/_jsx(NewPharmacyPrescription, {
                patient: patient,
                check: check,
                handler: handler
              })
            }, 2), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Eyeglasses, {
                  size: 30
                }), "LUNETTERIE"]
              }),
              children: /*#__PURE__*/_jsx(NewGlassPrescription, {
                patient: patient,
                check: check,
                handler: handler
              })
            }, 3), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Tools, {
                  size: 30
                }), "CHIRURGIE"]
              }),
              children: /*#__PURE__*/_jsx(NewChirurgyPrescription, {
                patient: patient,
                check: check,
                handler: handler
              })
            }, 4), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(SlashSquareFill, {
                  size: 30
                }), "LASER"]
              }),
              children: /*#__PURE__*/_jsx(NewLaserPrescription, {
                patient: patient,
                check: check,
                handler: handler
              })
            }, 5)]
          })
        })]
      })
    })
  });
};

export default Prescriptions;